import { useEffect, useState } from 'react';
import { useEmitter } from 'hooks/useEmitter';
import CardCandidat from 'components/3catinfo/Eleccions/LlistatCandidats/CardCandidat';
import Titol from 'components/3catinfo/Titol';
import Mosaic from 'components/3catinfo/Mosaic';
import TabSelector from 'components/3catinfo/Tabs/TabSelector';
import __isEmpty from 'lodash/isEmpty';
import styles from './llistatcandidats.module.scss';

const Candidat = (item) => {
    const { nom, partit, id, partits, color } = item;
    const colorPartit = partits?.find((p) => p.id === id)?.rgbcolor ?? color;

    return (
        <div
            className={styles.wrapperCandidat}
            style={{ '--color-candidat': colorPartit, 'borderLeft': '5px solid var(--color-candidat)' }}
        >
            <span className={styles.nom}>{nom}</span>
            <span className={styles.partit}>{partit}</span>
        </div>
    );
};

const LlistatCandidats = (props) => {
    const { tabsData } = props;
    const { onEmitter } = useEmitter();
    const [tabSelected, setTabSelected] = useState(0);
    const [itemsSelected, setItemsSelected] = useState(tabsData[0]?.valor);
    const titol = 'També es presenten';
    const [announcement, setAnnouncement] = useState('');
    const [toggleMessage, setToggleMessage] = useState(true);

    useEffect(() => {
        setAnnouncement(toggleMessage ? "S'ha mostrat nou contingut" : "S'ha carregat nou contingut");
        setToggleMessage(!toggleMessage);
        setTimeout(() => {
            setAnnouncement('');
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabSelected]);

    onEmitter('eleccions-candidats', (value) => {
        const index = tabsData.findIndex((tab) => tab.valor === value);
        setTabSelected(index !== -1 ? index : 0);
        setItemsSelected(value);
    });

    return (
        <>
            <TabSelector tabId='eleccions-candidats' items={tabsData} estils='pb-0 mb-500' estilBotons='petit' />
            <div className={styles.contentCandidats}>
                {props[itemsSelected.items]?.items.length > 0 && (
                    <div>
                        <ul className={styles.listItems}>
                            {props[itemsSelected.items]?.items.map((item, index) => (
                                <CardCandidat
                                    {...item}
                                    key={`card-candidat-${item.nom}`}
                                    partits={tabsData?.[tabSelected]?.partits}
                                />
                            ))}
                        </ul>
                        {!__isEmpty(props[itemsSelected.items]?.itemsAltresCandidats) && (
                            <div className={styles.contentAltresCandidats}>
                                <Titol tag='h2' titol={titol} estil='ambParagraf' />
                                <Mosaic numColumns={4} numColumnsMobile={1} estilMosaic={'menuDirectes'} hGap={300} vGap={300}>
                                    {props[itemsSelected.items]?.itemsAltresCandidats?.map((item) => {
                                        return (
                                            <Candidat
                                                key={`candidat-${item.id}`}
                                                {...item}
                                                partits={tabsData?.[tabSelected]?.partits}
                                            />
                                        );
                                    })}
                                </Mosaic>
                            </div>
                        )}
                    </div>
                )}
                <div aria-live='assertive' className={styles.announcement}>
                    {announcement}
                </div>
            </div>
        </>
    );
};

export default LlistatCandidats;
